import api from "@/lib/api";

function urlBase64ToUint8Array(b64) {
    const padding = "=".repeat((4 - (b64.length % 4)) % 4);
    const base64 = (b64 + padding).replace(/-/g, "+").replace(/_/g, "/");
    const raw = window.atob(base64);
    const arr = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
    return arr;
}

export function pushSupported() {
    return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export async function getCurrentSubscription() {
    if (!pushSupported()) return null;
    const reg = await navigator.serviceWorker.getRegistration("/sw.js");
    if (!reg) return null;
    return await reg.pushManager.getSubscription();
}

export async function subscribePush() {
    if (!pushSupported()) throw new Error("push not supported in this browser");
    const perm = await Notification.requestPermission();
    if (perm !== "granted") throw new Error("permission denied");

    let reg = await navigator.serviceWorker.getRegistration("/sw.js");
    if (!reg) reg = await navigator.serviceWorker.register("/sw.js");
    await navigator.serviceWorker.ready;

    const { data } = await api.get("/push/vapid");
    const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(data.public_key),
    });
    await api.post("/push/subscribe", sub.toJSON());
    return sub;
}

export async function unsubscribePush() {
    const sub = await getCurrentSubscription();
    if (!sub) return;
    try {
        await api.post("/push/unsubscribe", { endpoint: sub.endpoint });
    } catch (e) {}
    await sub.unsubscribe();
}
